<template>
    <div class="nevs-content">
        <div class="help-disclaimer" v-html="$LANG.Get('texts.helpDisclaimer')"></div>
        <NevsTabs class="help-tabs" :tabs="tabList" v-model="currentTab"></NevsTabs>
        <NevsTab :value="1" v-model="currentTab">
            <HelpFiskal></HelpFiskal>
        </NevsTab>
        <NevsTab :value="2" v-model="currentTab">
            <HelpEInvoices></HelpEInvoices>
        </NevsTab>
    </div>
</template>

<script>
import NevsTabs from "@/components/nevs/NevsTabs.vue";
import NevsTab from "@/components/nevs/NevsTab.vue";
import HelpFiskal from "@/components/general/HelpFiskal.vue";
import HelpEInvoices from "@/components/general/HelpEInvoices.vue";

export default {
    name: "ModuleHelp",
    components: {HelpEInvoices, HelpFiskal, NevsTabs, NevsTab},
    data() {
        return {
            currentTab: 1
        }
    },
    computed: {
        tabList() {
            return [
                {value: 1, label: this.$LANG.Get('buttons.helpFiskal')},
                {value: 2, label: this.$LANG.Get('buttons.helpEInvoices')}
            ];
        }
    },
    watch: {},
    mounted() {
        this.$store.commit('selectMenu', 'help');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.help'),
                link: null
            }
        ]);

    }
}
</script>

<style scoped>
    .help-disclaimer {
        padding: 10px;
        font-size: 16px;
    }

    .help-tabs {
        margin-top: 10px;
        margin-bottom: 6px;
    }
</style>